import React from 'react';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { Page } from 'ui/components';
import {
  SkeletonTable,
  Skeletons,
  SkeletonPageFooter,
} from 'ui/components/skeleton';

import useTable from 'ui/components/table';

import tableConfig from './component/table/config';
import Filter from './component/table/filter';

const initialState = {
  displayFilter: false,
  count: [],
};

const FulfillmentScreen = () => {
  const FulfillmentTable = useTable('fulfillment', tableConfig);
  const selectedWarehouse = useSelector((state) => state?.Auth?.selectedWarehouse);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ displayFilter, count }, setState] = React.useState(initialState);

  React.useEffect(() => {
    const filters = {
      warehouse_id: selectedWarehouse?.id,
    };

    FulfillmentTable.boot(filters);
  }, []);

  return (
    <Page className="fixed">
      <Page.Header
        pretitle="Daftar"
        className="bg-white"
        title={'Fulfillment'}
        isLoading={StateLoading}
      />

      <Page.Navigation toolbar>
        <FulfillmentTable.Tools downloadable isLoading={StateLoading}>
          {StateLoading ? (
            <div className="ms-2">
              <Skeletons height="35px" width="50px" />
            </div>
          ) : (
            <Button
              variant={displayFilter ? 'primary' : 'secondary'}
              className="ms-2 position-relative"
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  displayFilter: !displayFilter,
                }))
              }
            >
              <Fi.FiFilter size={19} color="white" />
              {count?.length > 0 ? (
                <span className="position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-danger">
                  {count?.length}
                </span>
              ) : null}
            </Button>
          )}
        </FulfillmentTable.Tools>
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div
          className={cn(
            displayFilter ? 'col-md-9  m-0 p-0' : 'col-md-12   m-0 p-0'
          )}
        >
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={9} />
          ) : (
            <FulfillmentTable.Render />
          )}
        </div>

        <Filter
          table={FulfillmentTable}
          onClose={() =>
            setState((prevState) => ({
              ...prevState,
              displayFilter: false,
            }))
          }
          show={displayFilter}
          setCount={(x) =>
            setState((prevState) => ({
              ...prevState,
              count: x,
            }))
          }
        />
      </Page.Body>
      <Page.Footer>
        {StateLoading ? (
          <SkeletonPageFooter />
        ) : (
          <FulfillmentTable.Pagination />
        )}
      </Page.Footer>
    </Page>
  );
};

export default FulfillmentScreen;
